/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type QueryCustomerV2QueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input']
  customerTenant: Types.Scalars['String']['input']
}>

export type QueryCustomerV2Query = {
  __typename?: 'Query'
  customerV2: {
    __typename?: 'CustomerV2'
    id: string
    customerTenant: string
    givenName: string | null
    familyName: string | null
    emailAddress: string | null
    phoneNumber: string | null
    languageCode: string | null
    flags: Array<Types.CustomerFlag>
    createdAt: string | null
    modifiedAt: string | null
    isManagedByApp: boolean
    appManagedFields: {
      __typename?: 'AppCustomerInformation'
      createdIpAddress: string | null
      deletionScheduledAt: any | null
      emailVerified: boolean | null
      phoneVerified: boolean | null
      extendedWalkingTime: boolean | null
      hvvPartnershipValidUntil: any | null
      locale: string | null
      status: Types.CustomerStatus
      visualImpairment: boolean | null
      wheelchairAccess: boolean | null
      legalDocumentConfirmations: Array<{
        __typename?: 'LegalDocumentConfirmation'
        confirmationDate: any | null
        legalDocumentId: string
        legalDocumentType: Types.Type
        version: number
      }>
      severelyDisabled: {
        __typename?: 'SeverelyDisabled'
        eligibility: Types.Eligibility | null
        validUntil: any | null
      } | null
      statusHistory: Array<{
        __typename?: 'StatusHistoryEntry'
        action: Types.StatusHistoryEntryAction
        disabledReason: Types.DisabledReason | null
        timestamp: any
      }> | null
    } | null
  } | null
}

export const QueryCustomerV2Document = gql`
    query queryCustomerV2($id: ID!, $customerTenant: String!) {
  customerV2(id: $id, customerTenant: $customerTenant) {
    id
    customerTenant
    givenName
    familyName
    emailAddress
    phoneNumber
    languageCode
    flags
    createdAt
    modifiedAt
    isManagedByApp
    appManagedFields {
      createdIpAddress
      deletionScheduledAt
      emailVerified
      phoneVerified
      extendedWalkingTime
      hvvPartnershipValidUntil
      legalDocumentConfirmations {
        confirmationDate
        legalDocumentId
        legalDocumentType
        version
      }
      locale
      severelyDisabled {
        eligibility
        validUntil
      }
      status
      statusHistory {
        action
        disabledReason
        timestamp
      }
      visualImpairment
      wheelchairAccess
    }
  }
}
    `

/**
 * __useQueryCustomerV2Query__
 *
 * To run a query within a React component, call `useQueryCustomerV2Query` and pass it any options that fit your needs.
 * When your component renders, `useQueryCustomerV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCustomerV2Query({
 *   variables: {
 *      id: // value for 'id'
 *      customerTenant: // value for 'customerTenant'
 *   },
 * });
 */
export function useQueryCustomerV2Query(
  baseOptions: Apollo.QueryHookOptions<
    QueryCustomerV2Query,
    QueryCustomerV2QueryVariables
  > &
    (
      | { variables: QueryCustomerV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<QueryCustomerV2Query, QueryCustomerV2QueryVariables>(
    QueryCustomerV2Document,
    options,
  )
}
export function useQueryCustomerV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryCustomerV2Query,
    QueryCustomerV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    QueryCustomerV2Query,
    QueryCustomerV2QueryVariables
  >(QueryCustomerV2Document, options)
}
// @ts-ignore
export function useQueryCustomerV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryCustomerV2Query,
    QueryCustomerV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryCustomerV2Query,
  QueryCustomerV2QueryVariables
>
export function useQueryCustomerV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryCustomerV2Query,
        QueryCustomerV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryCustomerV2Query | undefined,
  QueryCustomerV2QueryVariables
>
export function useQueryCustomerV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryCustomerV2Query,
        QueryCustomerV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    QueryCustomerV2Query,
    QueryCustomerV2QueryVariables
  >(QueryCustomerV2Document, options)
}
export type QueryCustomerV2QueryHookResult = ReturnType<
  typeof useQueryCustomerV2Query
>
export type QueryCustomerV2LazyQueryHookResult = ReturnType<
  typeof useQueryCustomerV2LazyQuery
>
export type QueryCustomerV2SuspenseQueryHookResult = ReturnType<
  typeof useQueryCustomerV2SuspenseQuery
>
export type QueryCustomerV2QueryResult = Apollo.QueryResult<
  QueryCustomerV2Query,
  QueryCustomerV2QueryVariables
>
